import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { HeaderService } from './header.service';
import { AppSelectorService } from '../../shared/services/app-selector/app-selector.service';
import { SidebarService } from '../sidebar/sidebar.service';
import { DatacontextService } from '../../data/datacontext.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { TrialUserService } from 'src/app/shared/services/trial-user/trial-user.service';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';
import { UserInfoService } from 'src/app/shared/services/user-info/user-info.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { SwitchPanelComponent } from '../switch-panel/switch-panel.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ]
    )
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public companyDetails: any = { name: '' };
  public selectedApp: any;
  public userData: any = {
    name: '',
    email: ''
  };
  headerData: any = {
    title: '',
    breadCrumb: []
  };

  public settingMenuItem = [
    {
      featureName: 'apps',
      hide: false,
      section: 'apps',
      text: 'Apps',
      img: 'assets/images/app.svg'
    },
    // {
    //   featureName: 'data_sources',
    //   hide: false,
    //   section: 'ds',
    //   text: 'Data Sources'
    // },
    {
      featureName: 'user_management',
      hide: false,
      section: 'users',
      text: 'User Management',
      img: 'assets/images/all_users.svg'
    },
    {
      featureName: 'activity_logs',
      hide: false,
      section: 'activity-logs',
      text: 'Activity Logs',
      img: 'assets/images/Logs.svg'
    },
  ];

  public profileSettings: any = {
    profile: {
      pathString: 'user_settings.profile_settings',
      hide: false,
    }
  };

  subHeaderData: any = {
    label: [],
    selectedTab: 0
  };
  public events;
  public email;
  public istrialUser = false;
  public trialDaysRemaining;
  public trialUserData: any;
  private switchPanelRef: MatDialogRef<SwitchPanelComponent>;
  private subs = new SubSink();

  constructor(private authentication: AuthenticationService,
    public headerService: HeaderService,
    private router: Router,
    private userInfo: UserInfoService,
    private appSelectorService: AppSelectorService,
    private datacontextService: DatacontextService,
    private trialUserService: TrialUserService,
    private amplitudeLoggerService: AmplitudeLoggerService,
    private featureListJsonService: FeatureListJsonService,
    private dialog: MatDialog,
    private sidebarService: SidebarService,
  ) {
    const _this = this;

    _this.selectedApp = _this.appSelectorService.getSelectedApp();
    this.subs.sink = _this.appSelectorService.getAppChangedListener().subscribe((selectedApp) => {
      _this.selectedApp = selectedApp;
      _this.shouldSettingMenuBeHidden();
      _this.shouldProfileSettingBeHidden();
    });

    // Subscribed to header data change event
    this.subs.sink = this.headerService.getHeaderEmitter().subscribe((_data) => {
      setTimeout(function () {
        if (_data.selectedApp) {
          _this.selectedApp = _data.selectedApp;
          delete _data.selectedApp;
        } else {
          _this.selectedApp = _this.appSelectorService.getSelectedApp();
        }
        _this.headerData = _data;
      });
    });

    // Subscribed to sub-header data change event
    this.subs.sink = this.headerService.getSubheaderEmitter().subscribe((_data) => {
      setTimeout(function () {
        _this.subHeaderData = _data;
      });
    });

    // Subscribed to profile data change event
    this.subs.sink = this.headerService.getProfileChangeEmitter().subscribe((_data) => {
      setTimeout(function () {
        _this.userData.name = _data.name;
      });
    });

    // wait for onsite auth to be successful before fetching company details
    this.subs.sink = this.authentication.onsiteUserAuth$.subscribe(() => {
      this.fetchCompanyDetailsAndUserInfo();
    });
  }

  shouldSettingMenuBeHidden() {
    this.settingMenuItem.forEach(menu => {
      this.featureListJsonService.shouldEnableTheFeature(`account_settings.${menu.featureName}.cta`, 'hidden', flag => menu.hide = flag);
    });
  }

  shouldProfileSettingBeHidden() {
    for (const key in this.profileSettings) {
      // tslint:disable-next-line: max-line-length
      this.featureListJsonService.shouldEnableTheFeature(`${this.profileSettings[key]['pathString']}`, 'hidden', flag => this.profileSettings[key]['hide'] = flag);
    }
  }

  ngOnInit() {
    this.shouldSettingMenuBeHidden();
    this.shouldProfileSettingBeHidden();
    this.trialUserData = this.trialUserService.trialUserData;
    if (!this.authentication.isIframe()) {
      this.fetchCompanyDetailsAndUserInfo();
    }
    this.subs.sink = this.router.events.subscribe((val: any) => {
      if (val.url && !(val.url.includes('noResetSubHeader'))) {
        this.resetSubHeaderData();
      }
      if (val.url && !(val.url.includes('noResetHeader'))) {
        this.resetHeaderData();
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  logout() {
    this.amplitudeLoggerService.resetUser();
    this.authentication.logout();
  }

  trackClick(event, cta, eventData) {
    this.amplitudeLoggerService.log(event, cta, eventData);
  }

  handlePlanClick() {
    let { eventName, eventAction } = AnalyticsEvents;
    let planViewCta = '';
    let planClickCta = '';
    switch (this.companyDetails.plan) {
      case 'user_onboarding':
        planViewCta = eventAction.ONBOARD;
        planClickCta = eventAction.HANSEL_ONBOARD;
        break;
      case 'pro':
        planViewCta = eventAction.PRO;
        planClickCta = eventAction.HANSEL_OPTIMIZE;
        break;
      case 'advanced':
        planViewCta = eventAction.ADVANCED;
        planClickCta = eventAction.HANSEL_OPTIMIZE;
        break;
    }
    this.trackClick(eventName.BILLING_PAGE_CLICK, planClickCta, {
      email: this.email,
      app_name: this.selectedApp.name
    });
    this.trackClick(eventName.BILLING_PLAN_VIEW, planViewCta, { email: this.email, company: this.companyDetails.name });
    if (this.companyDetails.plan === 'user_onboarding') {
      this.changeRoute('/settings', { 'section': 'billing' });
    }
  }

  onClickLabel(labelObj: any) {
    if (labelObj.index < 0 || (labelObj.index === this.subHeaderData.selectedTab)) {
      return;
    }
    const labelData = this.subHeaderData.labels[labelObj.index];
    if (labelData.cb) {
      this.subHeaderData.selectedTab = labelObj.index;
      setTimeout(() => {
        this.subHeaderData.selectedTab = 0;
      });
      return labelData.cb(labelData);
    } else if (labelData.href) {
      this.redirect(labelData);
    } else {
      this.headerService.triggerSubHeaderCallbackEvent('labelClk', labelData);
    }
  }

  onClickBackBtn(backBtnData) {
    this.headerService.triggerSubHeaderCallbackEvent('backBtnClk', backBtnData);
  }

  redirect(labelData: any) {
    if (labelData.queryParams) {
      this.router.navigate([labelData.href], { queryParams: labelData.queryParams });
    } else {
      this.router.navigate([labelData.href]);
    }
  }

  resetHeaderData() {
    this.headerData = {
      title: '',
      breadCrumb: []
    };
  }

  resetSubHeaderData() {
    this.subHeaderData = {
      label: [],
      selectedTab: 0
    };
  }

  ifBackBtnPresent() {
    return (this.subHeaderData.labels &&
      this.subHeaderData.labels.length &&
      this.subHeaderData.labels[0].icon &&
      (this.subHeaderData.labels[0].icon === 'arrow_back'));
  }

  getUserInfo() {
    this.datacontextService.user.getUserInfo((res: any) => {
      this.userData = res.api_response;
      this.email = this.userData.email;
    });
  }

  getCompanyInfo() {
    this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.companyDetails = _companyDetails;
    });
  }

  changeRoute(url: any, queryParmas?) {// change route
    this.router.navigate([url], { queryParams: queryParmas }).catch(err => {
      // Handle here
      window.history.pushState({}, document.title, url + '?' + (queryParmas ? this.serialize(queryParmas) : ''));
      window.location.reload();
    });
  }

  serialize(obj) {
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }

  isHomeButtonPresent() {
    return (!this.headerData.homeBtnCb && !this.headerData.disableHeader) || (this.headerData.homeBtnCb && !this.headerData.disableHeader);
  }

  openSwitchPanelDialog() {
    let panelClass = ['switch-panel-dialog', 'no-padding', 'white-bg', 'animate__animated', 'animate__slideInLeft'];
    this.switchPanelRef = this.dialog.open(SwitchPanelComponent, {
      panelClass: panelClass,
      maxHeight: "100vh",
      maxWidth: "100vw",
      height: "100%",
      disableClose: true
    });

    this.switchPanelRef.backdropClick().subscribe(() => {
      document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInLeft")
      document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutLeft");
      setTimeout(() => { this.switchPanelRef.close() }, 1000);
    });
  }

  getFormattedDate(date) {
    return moment(date, 'x').format('MMM DD, YYYY hh:mm a')
  }

  isNeverEndingJourneyDate(date) {
    try {
      const endDate = moment(date, 'x');
      if (endDate.year() === 2085) {
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

  fetchCompanyDetailsAndUserInfo() {
    this.getCompanyInfo();
    this.getUserInfo();
  }
}
